var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.0606 6.46738L10.5921 13.9359C10.2666 14.2613 9.73901 14.2613 9.41357 13.9359L1.94507 6.46738","stroke":"#19191B","strokeWidth":"2.25","strokeLinecap":"round"}));
}

CaretDown.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
